import React, { useState, useRef } from 'react';
import { MoveHorizontal } from 'lucide-react';
import './BeforeAfterSlider.css';

const BeforeAfterSlider = () => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  const handleMove = (clientX) => {
    if (!containerRef.current) return;
    
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    
    // Limit between 0 and 100
    const newPosition = Math.max(0, Math.min(100, percentage));
    setSliderPosition(newPosition);
  };

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    handleMove(e.clientX);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    handleMove(e.touches[0].clientX);
  };

  React.useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchmove', handleTouchMove);
      document.addEventListener('touchend', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleMouseUp);
    };
  }, [isDragging]);

  return (
    <section className="before-after-section">
      <div className="before-after-container">
        <p className="before-after-tagline">
          Manchmal braucht das Auto auch von innen eine Reinigung
        </p>
        <h2 className="before-after-title">Schieben Sie den Regler, um den Unterschied zu sehen</h2>

        <div 
          className="comparison-container"
          ref={containerRef}
          onMouseDown={handleMouseDown}
          onTouchStart={handleMouseDown}
        >
          {/* Before Image (Dirty) */}
          <div className="comparison-image before-image">
            <img 
              src="/motor-dirty-new.webp" 
              alt="Motor vor der Reinigung"
              draggable="false"
            />
            <div className="image-label before-label">Vorher</div>
          </div>

          {/* After Image (Clean) */}
          <div 
            className="comparison-image after-image"
            style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
          >
            <img 
              src="/motor-clean-new.webp" 
              alt="Motor nach der Reinigung"
              draggable="false"
            />
            <div className="image-label after-label">Nachher</div>
          </div>

          {/* Slider */}
          <div 
            className="slider-handle"
            style={{ left: `${sliderPosition}%` }}
          >
            <div className="slider-line"></div>
            <div className="slider-button">
              <MoveHorizontal size={24} />
            </div>
          </div>
        </div>

        <p className="before-after-note">
          Mit Trockeneisstrahlung erreichen wir eine gründliche Reinigung ohne Beschädigung empfindlicher Teile – 
          für ein makelloses Ergebnis, das überzeugt.
        </p>

        <div className="before-after-footer">
          <p className="before-after-cta">Holen Sie sich noch heute unverbindlich ein Angebot!</p>
          <p className="before-after-subtitle">Alle Preise auf Anfrage – lassen Sie uns zusammen eine maßgeschneiderte Lösung für Ihre Anforderungen finden.</p>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSlider;